// extracted by mini-css-extract-plugin
export default {"Container":"CustomLinks_Container__Jhw3g"};